// extracted by mini-css-extract-plugin
export default {"user":"user_user__rhLpM","name":"user_name__eSObZ","avatar":"user_avatar__0FcLO"};